var webgpuVS = `
#define VERTEXSHADER
`;

export { webgpuVS as default };
